import { ComposerMode } from '../types/index';
export function approvedRequestFieldsLocked(params) {
    var isRequestOnlySpace = params.isRequestOnlySpace, composerMode = params.composerMode, approved = params.approved, canApprove = params.canApprove, approvalPermissionLoading = params.approvalPermissionLoading;
    if (!isRequestOnlySpace)
        return false;
    if (composerMode !== ComposerMode.EDIT)
        return false;
    // Pending requests often have space response_status "accepted" before admin
    // approval — lock on approval status only, not space RSVP.
    if (approved !== true)
        return false;
    return approvalPermissionLoading || !canApprove;
}
